export const APPROVE_TOKEN = 'APPROVAL/APPROVE_TOKEN';
export const CANCEL_APPROVE_TOKEN = 'APPROVAL/CANCEL_APPROVE_TOKEN';

export const GET_SNT_ALLOWANCE = 'APPROVAL/GET_SNT_ALLOWANCE';
export const GET_SNT_ALLOWANCE_SUCCEEDED = 'APPROVAL/GET_SNT_ALLOWANCE_SUCCEEDED';
export const GET_SNT_ALLOWANCE_FAILED = 'APPROVAL/GET_SNT_ALLOWANCE_FAILED';

export const GET_TOKEN_ALLOWANCE = 'APPROVAL/GET_TOKEN_ALLOWANCE';
export const GET_TOKEN_ALLOWANCE_SUCCEEDED = 'APPROVAL/GET_TOKEN_ALLOWANCE_SUCCEEDED';
export const GET_TOKEN_ALLOWANCE_FAILED = 'APPROVAL/GET_TOKEN_ALLOWANCE_FAILED';

export const APPROVE_PRE_SUCCEEDED = 'APPROVAL/APPROVE_PRE_SUCCEEDED';
export const APPROVE_SUCCEEDED = 'APPROVAL/APPROVE_SUCCEEDED';
export const APPROVE_FAILED = 'APPROVAL/APPROVE_FAILED';
